'use client';

import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { NavbarAccountControls } from '@/components/layout/navbar-account-controls';
import type { MobileSidePanelTheme } from '@/components/layout/mobile-app-side-panel-theme';
import { Button } from '@/components/ui/button';
import { SheetHeader, SheetTitle, SheetDescription } from '@/components/ui/sheet';
import { useRTLUtils } from '@/lib/translation';
import { cn } from '@/lib/utils';

export function MobileAppSideSheetHeader({
  theme,
  onClose,
}: {
  theme: MobileSidePanelTheme;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const { directionClass } = useRTLUtils();
  const accountTheme = theme === 'enterprise' ? 'enterprise' : 'navbar';

  return (
    <div
      className={cn(
        'shrink-0 px-2 py-1.5',
        directionClass,
        theme === 'enterprise'
          ? 'border-b border-emerald-800/70'
          : 'border-b border-gray-200 dark:border-gray-800',
      )}
    >
      <SheetHeader className="sr-only">
        <SheetTitle>{t('account.settings')}</SheetTitle>
        <SheetDescription>{t('navigation.menu')}</SheetDescription>
      </SheetHeader>
      <NavbarAccountControls
        variant="sheet"
        theme={accountTheme}
        embeddedInHeader
        onProfileNavigate={onClose}
        headerTrailing={
          <Button
            variant="ghost"
            size="icon"
            className={cn(
              'h-8 w-8 shrink-0 touch-manipulation',
              theme === 'enterprise'
                ? 'text-emerald-200/80 hover:text-white'
                : 'text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-100',
            )}
            onClick={onClose}
            aria-label={t('common.close', 'Close')}
          >
            <X className="h-4 w-4" />
          </Button>
        }
      />
    </div>
  );
}
